import * as React from "react"
const WorkshopCalendarIconMoblie = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={12}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.125}
      d="M7.75 1v2.25M3.25 1v2.25M1 5.5h9M4.937 7.75H5.5v1.688M1 3.25a1.125 1.125 0 0 1 1.125-1.125h6.75A1.125 1.125 0 0 1 10 3.25V10a1.125 1.125 0 0 1-1.125 1.125h-6.75A1.125 1.125 0 0 1 1 10V3.25Z"
    />
  </svg>
)
export default WorkshopCalendarIconMoblie
